<template>
  <div>
    <div class="big-title">
      <span>地区及机构</span>
    </div>
    <a-row>
      <a-row :gutter="4">
        <a-col :span="10">
          <span class="list-header">抽检数量</span>
        </a-col>
        <a-col :span="10">
          <span class="list-header">机构选择</span>
        </a-col>
        <a-col :span="4">

        </a-col>
      </a-row>
      <a-row v-for="(task,index) in localValue" :key="index" :gutter="4" :style="{margin:'4px'}">
        <a-col>
          <a-row v-if="(!disabled)||task.execDept">
            <a-col :span="10">
              <a-input-number size="large" v-for="itemItem in task.monitTaskRegionList" v-model="itemItem.pickCount" allowClear placeholder="请输入抽检数量" @change="changeTask(task)"></a-input-number>
            </a-col>
            <a-col :span="10">
              <a-ext-gov-select :disabled="disabled" v-model="task.execDept"></a-ext-gov-select>
            </a-col>
            <a-col :span="4">
              <a-button v-if="index" type="link" @click="removeItem(task)">删除</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row :gutter="4" :style="{margin:'4px'}">
        <a-col :span="10">
          <a-button type="link" icon="plus" @click="addItem">
            添加
          </a-button>
        </a-col>
        <a-col :span="10">
          <div v-if="!disabled" class="total-box">
            总数量：<span style="color: red">{{total}}</span>
          </div>
        </a-col>
        <a-col :span="4">
        </a-col>
      </a-row>
    </a-row>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
//TODO: 修改
import {getRegion as initRegion} from '../../../api/api'
//TODO: 修改
import {getRegionTree as initGov} from '../../../api/api'
import _ from 'lodash'

import AExtGovSelect from './AExtGovSelect'
export default {
    name: "index",
    mixins:[mixin],
    components:{AExtGovSelect},
    props:{
      region:{
          type:String,
          default:''
      },
        //sync修饰
        total:{
            type:Number,
            default:0
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            options:[],
            localValue: [],
            blankTask:null
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            // for (let i=0;i<this.localValue.length;i++)
            // {
            //     this.localValue[i].monitTaskRegionList.push({regionName:this.localValue[i].regionName,pickCount:1});
            // }
            let total=this.getMonitTargetCount(this.localValue);
            this.total=total;
        },
        changeTask()
        {
            let total=this.getMonitTargetCount(this.localValue);
            this.total=total;
        },
        addItem()
        {
            let newTask=_.cloneDeep(this.blankTask);
            this.localValue.push(newTask);
            let total=this.getMonitTargetCount(this.localValue);
            this.$emit('update:total', total)
        },
        removeItem(task){
            this.localValue.remove(task);
            let total=this.getMonitTargetCount(this.localValue);
            this.$emit('update:total', total)
        },
        changeTask(task)
        {
            let totalRow = this.getMonitTargetCount(task.taskDetail);
            task.monitTargetCount=totalRow;
            let total=this.getMonitTargetCount(this.localValue);
            this.$emit('update:total', total)
        },
        getMonitTargetCount(arr)
        {
            if (arr)
            {
                let i=0;
                arr.forEach(item=>{
                    i+=item.monitTaskRegionList[0].pickCount;
                })
                return i;
            }
            else {
                return 0;
            }
        },
    }

}
</script>

<style scoped>
  .box{
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
  }

  .total-box{
    font-weight: 700;
    color: #7c7c7c;
  }

  /deep/ .ant-select-selection--single{
    height: 40px;
  }

  /deep/ .ant-select{
    vertical-align: top;
  }

  /deep/ .ant-select-selection__rendered{
    line-height: 40px;
    color: #7c7c7c;
    font-weight: 700;
  }

  /deep/ .ant-input-number {
    height: 40px;
    vertical-align: top;
    width: 100%;
  }
  .list-header {
    padding-left: 20px;
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>
